export default __webpack_public_path__ + "static/media/udacity-U-logo-60.b52de701.webp";